<template>
    <header class="container">
        <img src="@/assets/richie.png">
        <div class="profile-summary-text">
            <h1>{{ profile.name }}</h1>
            <h4>{{ profile.position }}</h4>
            <p class="body">{{ profile.description }}</p>
        </div>
    </header>
</template>

<script lang="ts">
import { ResumeProfile } from '@/models/Resume';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: "profile",
    props: {
        profile: {
            type: Object as PropType<ResumeProfile>,
            required: true
        } 
    }
})

</script>

<style scoped lang="stylus">

    @import "~../../src/styles/styles";

.container
    display: flex;
    flex-direction: row;
    align-items: center;
    gap spacing-24

.profile-summary-text
    display flex
    flex-direction column
    align-items flex-start
    gap: spacing-02
    order: 1;
    align-self: center;
    flex-grow: 0;
    // margin: 20px 0px;

img
    flex-shrink 0
    width 96pt
    height width
    background-color blue
    border 4px solid LightGray
    border-radius 50%

    border: 2px solid #C2C2C2;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

</style>